import { IonLoading } from "@ionic/react";
import { useSelector, useDispatch } from "react-redux";
import { selectCreateStatus } from "../../../store/profileForm/selector/selectCreateStatus";

export const FormLoading: React.FC = () => {
  const createStatus = useSelector(selectCreateStatus);
  return (
    <IonLoading
      cssClass="my-custom-class"
      isOpen={createStatus === "pending"}
      message={"Creando perfil..."}
    />
  );
};
